import { render, staticRenderFns } from "./sidebar_reviewers.vue?vue&type=template&id=36fcca16"
import script from "./sidebar_reviewers.vue?vue&type=script&lang=js"
export * from "./sidebar_reviewers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports